// Insert a Cloudinary transformation string into a delivery URL, right after
// the '/upload/' segment. No-ops for falsy or non-Cloudinary URLs.
const UPLOAD_MARKER = '/upload/';

function withTransform(url, transform) {
  if (!url) return url;
  const idx = url.indexOf(UPLOAD_MARKER);
  if (idx === -1) return url;
  const insertAt = idx + UPLOAD_MARKER.length;
  return `${url.slice(0, insertAt)}${transform}/${url.slice(insertAt)}`;
}

// Square-cropped thumbnail — for fixed-box, object-fit:cover-style contexts.
export function cloudinaryThumb(url, width) {
  return withTransform(url, `w_${width},c_fill,q_auto,f_auto`);
}

// Proportionally scaled, uncropped — for object-fit:contain hero images.
export function cloudinaryScaled(url, width) {
  return withTransform(url, `w_${width},q_auto,f_auto`);
}

// 1x/2x density srcset for fixed-size thumbnail boxes.
export function cloudinaryThumbSrcSet(url, width) {
  return `${cloudinaryThumb(url, width)} 1x, ${cloudinaryThumb(url, width * 2)} 2x`;
}

// Width-descriptor srcset for variable-width containers (pair with `sizes`).
export function cloudinaryScaledSrcSet(url, widths) {
  return widths.map((w) => `${cloudinaryScaled(url, w)} ${w}w`).join(', ');
}
